/** Service Type */

export const CREATE_SERVICE_GLOBAL = 'CREATE_SERVICE_GLOBAL';

export const GET_SERVICES = 'GET_SERVICES';
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS';

export const EDIT_SERVICE_BY_ID_GLOBAL = 'EDIT_SERVICE_BY_ID_GLOBAL';

export const DELETE_SERVICE_BY_ID_GLOBAL = 'DELETE_SERVICE_BY_ID_GLOBAL';

/** End */

/** Credentials */

export const CREATE_CREDENTIAL_GLOBAL = 'CREATE_CREDENTIAL_GLOBAL';

export const GET_CREDENTIAL_GLOBAL = 'GET_CREDENTIAL_GLOBAL';
export const GET_CREDENTIAL_GLOBAL_SUCCESS = 'GET_CREDENTIAL_GLOBAL_SUCCESS';

export const EDIT_CREDENTIAL_BY_ID_GLOBAL = 'EDIT_CREDENTIAL_BY_ID_GLOBAL';

export const DELETE_CREDENTIAL_BY_ID_GLOBAL = 'DELETE_CREDENTIAL_BY_ID_GLOBAL';

export const CREATE_COVERED_CREDENTIAL = 'CREATE_COVERED_CREDENTIAL';

export const EDIT_COVERED_CREDENTIAL = 'EDIT_COVERED_CREDENTIAL';
export const SELECTED_CREDENTIAL = 'SELECTED_CREDENTIAL';
export const REMOVE_SELECTED_CREDENTIAL = 'REMOVE_SELECTED_CREDENTIAL';

/** End */

/** Departments */

export const CREATE_DEPARTMENT_GLOBAL = 'CREATE_DEPARTMENT_GLOBAL';

export const GET_DEPARTMENTS = 'GET_DEPARTMENTS';
export const GET_DEPARTMENTS_SUCCESS = 'GET_DEPARTMENTS_SUCCESS';

export const EDIT_DEPARTMENT_BY_ID_GLOBAL = 'EDIT_DEPARTMENT_BY_ID_GLOBAL';

export const DELETE_DEPARTMENT_BY_ID_GLOBAL = 'DELETE_DEPARTMENT_BY_ID_GLOBAL';

/** End */

/** Job */

export const CREATE_JOB_GLOBAL = 'CREATE_JOB_GLOBAL';

export const GET_JOBS = 'GET_JOBS';
export const GET_JOBS_SUCCESS = 'GET_JOBS_SUCCESS';

export const EDIT_JOB_BY_ID_GLOBAL = 'EDIT_JOB_BY_ID_GLOBAL';

export const DELETE_JOB_BY_ID_GLOBAL = 'DELETE_JOB_BY_ID_GLOBAL';

/** End */

/** Place */

export const CREATE_PLACE_GLOBAL = 'CREATE_PLACE_GLOBAL';

export const GET_PLACES = 'GET_PLACES';
export const GET_PLACES_SUCCESS = 'GET_PLACES_SUCCESS';

export const EDIT_PLACE_BY_ID_GLOBAL = 'EDIT_PLACE_BY_ID_GLOBAL';

export const DELETE_PLACE_BY_ID_GLOBAL = 'DELETE_PLACE_BY_ID_GLOBAL';

/** End */

/** Company */

export const CREATE_COMPANY = 'CREATE_COMPANY';

export const GET_COMPANY = 'GET_COMPANY';
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';

export const EDIT_COMPANY = 'EDIT_COMPANY';

export const DELETE_COMPANY = 'DELETE_COMPANY';

export const GET_COMPANIES = 'GET_COMPANIES';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';

/** End */

/** Calendars */

export const DISCONNECT_CALENDAR = 'DISCONNECT_CALENDAR';
export const CHANGE_CALENDAR_STATUS = 'CHANGE_CALENDAR_STATUS';
export const GET_CONNECT_CALENDARS = 'GET_CONNECT_CALENDARS';
export const GET_CONNECT_CALENDARS_SUCCESS = 'GET_CONNECT_CALENDARS_SUCCESS';

/** End */

/** Stripe */
export const STRIPE_SETTINGS = 'STRIPE_SETTINGS';

/** End */

/** Bank */
export const CREATE_BANK = 'CREATE_BANK';

export const GET_BANKS = 'GET_BANKS';
export const GET_BANKS_SUCCESS = 'GET_BANKS_SUCCESS';

export const EDIT_BANK = 'EDIT_BANK';
export const DELETE_BANK = 'DELETE_BANK';

/** End */

/** Ai Integration */
export const CHANGE_AI_INTEGRATION = 'CHANGE_AI_INTEGRATION';

/** End */

/** Integrations */

export const GET_SYSTEM_INTEGRATIONS = 'GET_SYSTEM_INTEGRATIONS';
export const GET_SYSTEM_INTEGRATIONS_SUCCESS = 'GET_SYSTEM_INTEGRATIONS_SUCCESS';
export const CONNECT_INTEGRATION = 'CONNECT_INTEGRATION';
export const DISCONNECT_INTEGRATION = 'DISCONNECT_INTEGRATION';
export const EDIT_INTEGRATION_CONNECTION = 'EDIT_INTEGRATION_CONNECTION';
export const CAN_USE_INTEGRATION = 'CAN_USE_INTEGRATION';
export const CAN_USE_INTEGRATION_SUCCESS = 'CAN_USE_INTEGRATION_SUCCESS';
export const DELETE_INTEGRATION = 'DELETE_INTEGRATION';

/** End */

/** Stripe */
export const CONNECT_ZOOM = 'CONNECT_ZOOM';
export const CONNECTION_ZOOM_TO_THERAPY = 'CONNECTION_ZOOM_TO_THERAPY';
export const EDIT_ZOOM_STATUS = 'EDIT_ZOOM_STATUS';
export const CREATE_ZOOM_MEETING = 'CREATE_ZOOM_MEETING';
export const DELETE_ZOOM_MEETING = 'DELETE_ZOOM_MEETING';
export const GET_ZOOM_USERS = 'GET_ZOOM_USERS';
export const GET_ZOOM_USERS_SUCCESS = 'GET_ZOOM_USERS_SUCCESS';

/** End */

/** Telehealth */
export const GET_TELEHEALTH_STATUS = 'GET_TELEHEALTH_STATUS'
export const GET_TELEHEALTH_STATUS_SUCCESS = 'GET_TELEHEALTH_STATUS_SUCCESS'
/** End */

/** Supervision Config */
export const GET_SUPERVISION_CONFIG = 'GET_SUPERVISION_CONFIG';
export const GET_SUPERVISION_CONFIG_SUCCESS = 'GET_SUPERVISION_CONFIG_SUCCESS';
export const UPDATE_SUPERVISION_CONFIG = 'UPDATE_SUPERVISION_CONFIG';
/** End */

/** Clinical Settings */
export const UPDATE_CLINICAL_SETTINGS = 'UPDATE_CLINICAL_SETTINGS';
/** Success keys (not actions): one per setting, so each save toasts its own message — see utils/hooks/toastSuccess.js. */
export const CLINICAL_SETTINGS_SESSION_GOALS_SAVED = 'CLINICAL_SETTINGS_SESSION_GOALS_SAVED';
export const CLINICAL_SETTINGS_GOAL_ORDER_SAVED = 'CLINICAL_SETTINGS_GOAL_ORDER_SAVED';
/** End */

/** Eligibility Auto-Check Config */
export const GET_ELIGIBILITY_AUTO_CHECK_CONFIG = 'GET_ELIGIBILITY_AUTO_CHECK_CONFIG';
export const GET_ELIGIBILITY_AUTO_CHECK_CONFIG_SUCCESS = 'GET_ELIGIBILITY_AUTO_CHECK_CONFIG_SUCCESS';
export const UPDATE_ELIGIBILITY_AUTO_CHECK_CONFIG = 'UPDATE_ELIGIBILITY_AUTO_CHECK_CONFIG';
export const RUN_BATCH_ELIGIBILITY_CHECK = 'RUN_BATCH_ELIGIBILITY_CHECK';
/** End */

/** Members Portal Config */
export const GET_MEMBERS_PORTAL_CONFIG = 'GET_MEMBERS_PORTAL_CONFIG';
export const GET_MEMBERS_PORTAL_CONFIG_SUCCESS = 'GET_MEMBERS_PORTAL_CONFIG_SUCCESS';
export const UPDATE_MEMBERS_PORTAL_CONFIG = 'UPDATE_MEMBERS_PORTAL_CONFIG';
/** End */

/** Google Meet */
export const CONNECT_GOOGLE_MEET = 'CONNECT_GOOGLE_MEET'
export const CONNECTION_GOOGLE_MEET_TO_THERAPY = 'CONNECTION_GOOGLE_MEET_TO_THERAPY'
export const EDIT_GOOGLE_MEET_STATUS = 'EDIT_GOOGLE_MEET_STATUS'

/** End */
